// extracted by mini-css-extract-plugin
export default {"wrap":"Benefits_wrap__RV8q0","image":"Benefits_image__2YJOx","content":"Benefits_content__g0IOG","title":"Benefits_title__ppVnq","list":"Benefits_list__0ZToZ"};